
import ChargePointListPresenter from "../ChargePointList/ChargePointLIstPresenter";
import NbChargePointStation from "../ChargePointList/NbChargePointStation";
import AddNewChargeBtnModal from "../NewChargePoint/AddNewChargeBtnModal/AddNewChargeBtnModal";
import { FilterTimeWindowBtn, NbChargingSessionsProvided, TotalMoney } from "./AnalysisComp/AnalysisComp";
import NbKwhProvided from "./NbKwhProvided/NbKwhProvided";
import SingleStationActionBtnPresenter from "./SingleStationActionBtn/SingleStationActionBtnPresenter";
import SingleStationChargingSessionList from "./SingleStationChargingSessionList/SingleStationChargingSessionList";
import SingleStationCountryCity from "./SingleStationCountryCity";
import SingleStationImagePresenter from "./SingleStationImage/SingleStationImagePresenter";
import SingleStationName from "./SingleStationName/SingleStationName";
import StationChartEnergyActive from "./StationChartEnergyActive/StationChartEnergyActive";
import StationInfo from "./StationInfo";
import StationLocationPresenter from "./StationLocation/StationLocationPresenter";

export const SingleStation = {
    Name: SingleStationName,
    CountryCity: SingleStationCountryCity,
    CharePointList: ChargePointListPresenter,
    AddNewChargeBtnModal: AddNewChargeBtnModal,
    NbChargePoint: NbChargePointStation,
    ActionBtn: SingleStationActionBtnPresenter,
    LocationMap: StationLocationPresenter,
    StationInfo: StationInfo,
    ChargingSessionList: SingleStationChargingSessionList,
    Images: SingleStationImagePresenter, 
    NbKwhProvided: NbKwhProvided,
    NbChargingSessionsProvided: NbChargingSessionsProvided,
    TotalMoney: TotalMoney,
    Charts : {
        EnergyActive: StationChartEnergyActive,
        FilterTimeWindowBtn: FilterTimeWindowBtn
    }
}